import type { Cartesian3, Viewer } from '@cesiumgs/cesium-analytics'
import { CallbackProperty, Color, Entity, HeightReference, PolygonHierarchy } from '@cesiumgs/cesium-analytics'
import { type DrawOptions } from './DrawOptions'
import DrawLineAction from './DrawLineAction'

/**
 * Cesium Tool for Draw Polygon
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Polygon,null);
 * draw.on(DrawEventType.CursorUpdate,evt=>{
 * });
 * ```
 */
export default class DrawPolygonAction extends DrawLineAction {
  /**
   * @internal
   */
  vertexAddHandler(movement: any): void {
    super.vertexAddHandler(movement)
    /*  let position = this.viewer.scene.pickPosition(movement.position);
          this.drawResults?.postions.push(position);

          this.addEvt.raiseEvent(this.drawResults);
          this.renderResult = this.drawResults?.postions; */
  }

  /**
   * @internal
   */
  vertexCompleteHandler(movement: any): void {
    super.vertexCompleteHandler(movement)

    /*  this.viewer.trackedEntity = undefined;
          this.removeListener();
          this.complete(); */
  }

  /**
   * @internal
   */
  cursorUpdateHandler(movement: any): void {
    super.cursorUpdateHandler(movement)

    /* let position = this.viewer.scene.pickPosition(movement.endPosition);
         let res: DrawResult = {
           postions: [...this.drawResults.postions, position],
         };
         this.renderResult = res.postions;
         this.updateEvt.raiseEvent(res); */
  }

  /**
   * @internal
   */
  registerViewerEvent(): void {
    super.registerViewerEvent()
    /* this.vertexAddHandlerInstance.setInputAction(
          this.vertexAddHandler.bind(this),
          Cesium.ScreenSpaceEventType.LEFT_CLICK,
        );
        this.vertexCompleteHandlerInstance.setInputAction(
          this.vertexCompleteHandler.bind(this),
          Cesium.ScreenSpaceEventType.RIGHT_CLICK,
        );
        this.cursorUpdateHandlerInstance.setInputAction(
          this.cursorUpdateHandler.bind(this),
          Cesium.ScreenSpaceEventType.MOUSE_MOVE,
        ); */
  }

  /**
   * @internal
   */
  removeListener(): void {
    super.removeListener()
    /* this.vertexAddHandlerInstance?.removeInputAction(
          Cesium.ScreenSpaceEventType.LEFT_CLICK,
        );
        this.vertexCompleteHandlerInstance?.removeInputAction(
          Cesium.ScreenSpaceEventType.RIGHT_CLICK,
        );
        this.cursorUpdateHandlerInstance?.removeInputAction(
          Cesium.ScreenSpaceEventType.MOUSE_MOVE,
        ); */
  }

  /**
   * @internal
   */
  constructor(viewer: Viewer, options?: DrawOptions) {
    super(viewer, options)

    this.type = 'polygon'
    this.renderResult = new Array<Cartesian3>()

    if (this.drawoptions?.useDefaultEntity) {
      const addEntity
        = this.drawoptions?.defaultPolygonEntity
        || new Entity({
          polygon: {
            hierarchy: new CallbackProperty(() => {
              const arrPoint = new PolygonHierarchy(this.renderResult)
              return arrPoint
            }, false),
            heightReference: HeightReference.CLAMP_TO_GROUND,
            material: Color.fromCssColorString('rgba(255,213,0,0.3)'),
          },
        })

      this.addEntity = this.dataSource.entities.add(addEntity)
    }
  }
}
